
  import { Vue, Component } from "vue-property-decorator";
  import Search from "@/components/common/Search.vue";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      Search,
      UiButton,
    },
  })
  export default class SearchOnAction extends Vue {
    searchData: string = "";

    onSearch(): void {
      this.$emit("search", this.searchData);
    }

    onSearchUpdate(value: string): void {
      if (value.length === 0 && this.searchData.length !== 0) {
        this.searchData = "";
        this.onSearch();
      }

      this.searchData = value;
    }
  }
